import Favorites from './favorites';

export { Favorites };

export default Favorites;
